import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Base class of the services that talk to one BFF resource: it supplies the `HttpClient` and
 * the resource URL, `<apiUrl>/<path>`.
 *
 * Deliberately no more than that (#199):
 * - **No error handler.** Errors propagate unchanged; `CallApiService` logs and toasts them,
 *   and a subscriber without an error callback still gets RxJS's unhandled-error report.
 * - **No `JSON.stringify` and no `Content-Type` header.** `HttpClient` serialises an object
 *   body and sets `application/json` itself. Only a bare string body has to be serialised by
 *   hand — `HttpClient` would send it unquoted as `text/plain` (see `verifyTfa`).
 * - **No `get`/`post` wrappers.** `HttpClient` already is that API, with typed `params`,
 *   `responseType` and the rest; a second one would only hide them.
 */
export abstract class ApiServiceBase {
  protected readonly http = inject(HttpClient);

  /** The resource below the API root, e.g. `'order'` for `…/api/order`. */
  protected abstract readonly path: string;

  protected getUrl(): string {
    return `${environment.apiUrl}/${this.path}`;
  }
}
